module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ui.header) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('LopeHeader'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('LopeSidebar'), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('LopeFooter'), _vm._v(" "), _c('bootstrap-modal', {
    ref: "modal",
    attrs: {
      "title": _vm.ui.title,
      "id": "global-btmodal"
    }
  }, [_c(_vm.ui.currentView, {
    tag: "component",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  })], 1)], 1) : _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9d4272e2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 416
// module chunks = 2